export function getConstant(path, targetValue) {
  let array = CONSTANT;
  path.split('.').forEach((key) => {
    array = array[key];
  });
  if (array.find((c) => c.value === targetValue)) {
    return array.find((c) => c.value === targetValue);
  } else {
    return '';
  }
}

export const CONSTANT = {
  version: '2.7.3',
  maxImageSize: 20 * 1000000,
  shared: {
    draftTypes: [
      {
        label: 'Brouillon',
        value: true,
        bgColor: 'bg-orange-500'
      },
      {
        label: 'Publié',
        value: false,
        bgColor: 'bg-green-600'
      }
    ]
  },
  languages: [
    {
      label: 'Français',
      key: 'fr',
      code: 'fr'
    },
    {
      label: 'Anglais',
      key: 'en',
      code: 'gb'
    }
  ],
  superadmin: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Statistiques Globales',
        key: 'analytics',
        icon: 'analytics'
      }
    ]
  },
  analytics: {
    monthsRange: [
      {
        label: '12 derniers mois',
        value: 12
      },
      {
        label: '6 derniers mois',
        value: 6
      },
      {
        label: '3 derniers mois',
        value: 3
      }
    ]
  },
  collectifnode: {
    titleSize: 'text-xl',
    apps: [
      {
        label: 'Audience',
        key: 'analytics',
        icon: 'analytics'
      },

      {
        label: 'Projets',
        key: 'cnproject',
        icon: 'cnproject'
      }
    ],
    inProgress: [
      {
        label: 'Projet en cours',
        value: true,
        bgColor: 'bg-yellow-500',
        icon: 'in_progress'
      },
      {
        label: 'Projet terminé',
        value: false,
        bgColor: 'bg-green-700',
        icon: 'check'
      }
    ],
    analytics: [
      {
        label: 'Visites par pages',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit',
        scope: 'collectifnode',
        chartType: 'visitBarChart'
      },
      {
        label: 'Détail des visites par projet',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/realisations',
        scope: 'collectifnode',
        chartType: 'visitBarChart'
      },
      {
        label: 'Répartition des appareils utilisés',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'device',
        scope: 'collectifnode',
        chartType: 'devicePieChart'
      }
    ],
    propertyTypes: [
      {
        label: 'Technologie',
        value: 'cn_technology'
      },
      {
        label: 'Compétence',
        value: 'cn_skill'
      },
      {
        label: 'Type de projet',
        value: 'cn_project_type'
      }
    ]
  },
  prna: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Projets',
        key: 'prnaproject',
        icon: 'prnaproject'
      },
      {
        label: 'Actualités',
        key: 'prnacircumstance',
        icon: 'prnacircumstance'
      }
    ],

    statusTypes: [
      {
        label: 'Brouillon',
        value: 'draft',
        bgColor: 'bg-orange-500'
      },
      {
        label: 'Publié',
        value: 'published',
        bgColor: 'bg-green-700'
      }
    ],
    highlightFilter: [
      {
        label: 'Tous',
        value: 'false'
      },
      {
        label: 'Mis en avant',
        value: 'true'
      }
    ]
  },
  melismes: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Évenements',
        key: 'msevent',
        icon: 'msevent'
      },
      {
        label: 'Programmes',
        key: 'program',
        icon: 'program'
      },
      {
        label: 'Ressources',
        key: 'resource',
        icon: 'resource'
      }
    ],
    resourceTypes: [
      {
        value: 'record',
        label: 'Disque',
        icon: 'vinyl'
      },
      {
        value: 'audio',
        label: 'Audio',
        icon: 'micro'
      },
      {
        value: 'video',
        label: 'Vidéo',
        icon: 'camera'
      }
    ],
    eventDurations: [
      {
        label: '30 min',
        value: 30
      },
      {
        label: '45 min',
        value: 45
      },
      {
        label: '1 heure',
        value: 60
      },
      {
        label: '1 heure 15 min',
        value: 75
      },
      {
        label: '1 heure 30 min',
        value: 90
      },
      {
        label: '1 heure 45 min',
        value: 105
      },
      {
        label: '2 heures',
        value: 120
      },
      {
        label: '2 heures 15 min',
        value: 135
      },
      {
        label: '2 heures 30 min',
        value: 150
      },
      {
        label: '2 heures 45 min',
        value: 165
      },

      {
        label: '3 heures',
        value: 180
      },
      {
        label: '3 heures 15 min',
        value: 195
      },
      {
        label: '3 heures 30 min',
        value: 210
      },
      {
        label: '3 heures 45 min',
        value: 225
      },
      {
        label: '4 heures',
        value: 240
      }
    ],
    common: {
      statusTypes: [
        {
          label: 'Brouillon',
          value: 'draft',
          bgColor: 'bg-orange-500'
        },
        {
          label: 'Publié',
          value: 'published',
          bgColor: 'bg-green-700'
        }
      ]
    },
    analytics: [
      {
        label: 'Visites par pages',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit',
        scope: 'melismes',
        chartType: 'visitBarChart'
      },
      {
        label: 'Détail des visites par ressource',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/ressources',
        scope: 'melismes',
        chartType: 'visitBarChart'
      },
      {
        label: 'Détail des visites par programme',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/ressources',
        scope: 'melismes',
        chartType: 'visitBarChart'
      },
      {
        label: 'Répartition des appareils utilisés',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'device',
        scope: 'melismes',
        chartType: 'devicePieChart'
      }
    ]
  },
  solarys: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Ressources internes',
        key: 'syinternalresource',
        icon: 'house'
      },
      {
        label: 'Resources thématiques',
        key: 'syexternalresource',
        icon: 'tree'
      },
      {
        label: 'Évènements',
        key: 'syevent',
        icon: 'event'
      }
    ],
    resourceTypes: [
      {
        label: 'Fiche pratique',
        value: 'fiche_pratique'
      },
      {
        label: 'Article',
        value: 'article'
      },
      {
        label: 'Outil',
        value: 'outil'
      }
    ],
    publicList: [
      {
        label: 'Grand public',
        value: 'grand_public'
      },
      {
        label: 'Etudiants',
        value: 'etudiants'
      },
      {
        label: 'Collectivité',
        value: 'collectivite'
      },
      {
        label: 'Association étudiante',
        value: 'association_etudiante'
      },
      {
        label: 'Association',
        value: 'associations'
      }
    ],
    propertyTypes: [
      {
        label: 'Public cible',
        value: 'sy_public_list'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ],
    resourceThemes: [
      {
        label: 'Gestion des déchets',
        value: 'gestion_des_dechets'
      },
      {
        label: 'Adaptation',
        value: 'adaptation'
      },
      {
        label: 'Achats responsables',
        value: 'achats_responsables'
      },
      {
        label: 'Réemploi upcycling',
        value: 'reemploi_upcycling'
      },
      {
        label: 'Communication',
        value: 'communication'
      },
      {
        label: 'Restauration',
        value: 'restauration'
      },
      {
        label: 'Mobilités durables',
        value: 'mobilites_durables'
      },
      {
        label: "Économies d'Énergie",
        value: 'economies_denergie'
      },
      {
        label: 'Généralités',
        value: 'generalites'
      },
      {
        label: 'Événementiel',
        value: 'evenementiel'
      },
      {
        label: 'Eco-anxiété',
        value: 'eco_anxiete'
      },
      {
        label: 'Numérique responsable',
        value: 'numerique_responsable'
      },
      {
        label: 'Se former',
        value: 'se_former'
      }
    ],
    cities: [
      {
        label: 'Nantes',
        value: 'nantes'
      },
      {
        label: 'Rennes',
        value: 'rennes'
      }
    ],
    formatList: [
      {
        label: 'Atelier',
        value: 'atelier'
      },
      {
        label: 'Fresque',
        value: 'fresque'
      },
      {
        label: 'Conférence',
        value: 'conference'
      },
      {
        label: 'Table ronde',
        value: 'table-ronde'
      },
      {
        label: 'Débat',
        value: 'debat'
      },
      {
        label: 'Rencontre',
        value: 'rencontre'
      },
      {
        label: 'Webinaire',
        value: 'webinaire'
      },
      {
        label: 'Séminaire',
        value: 'seminaire'
      }
    ],
    themeList: [
      {
        label: 'Achats responsables',
        value: 'achats_responsables'
      },
      {
        label: 'Gestion des déchets',
        value: 'gestion_des_dechets'
      },
      {
        label: 'Mobilités durables',
        value: 'mobilites_durables'
      },
      {
        label: 'Généralités',
        value: 'generalites'
      },
      {
        label: 'Adaptation',
        value: 'adaptation'
      },
      {
        label: 'Réemploi/Upcycling',
        value: 'reemploi_upcycling'
      },
      {
        label: 'Communication',
        value: 'communication'
      },
      {
        label: 'Restauration',
        value: 'restauration'
      },
      {
        label: "Économies d'énergie",
        value: 'economies_denergie'
      },
      {
        label: 'Événementiel',
        value: 'evenementiel'
      },
      {
        label: 'Éco-anxiété',
        value: 'eco_anxiete'
      },
      {
        label: 'Numérique responsable',
        value: 'numerique_responsable'
      },
      {
        label: 'Se former',
        value: 'se_former'
      }
    ]
  },
  chiennoir: {
    titleSize: 'text-xl',
    availableLanguages: ['fr', 'en'],
    apps: [
      {
        label: 'Tous les projets',
        key: 'cngproject',
        icon: 'cngproject'
      },
      {
        label: 'Projets à la une',
        key: 'cngprojecthighlight',
        icon: 'star'
      },
      {
        label: 'Articles',
        key: 'cngnews',
        icon: 'news'
      },
      {
        label: 'Audience',
        key: 'analytics',
        icon: 'analytics'
      }
    ],
    languages: [
      {
        label: 'Français',
        value: 'fr',
        code: 'fr'
      },
      {
        label: 'Anglais',
        value: 'en',
        code: 'gb'
      }
    ],
    colors: [
      {
        value: 1,
        mainTextColor: '#121212',
        backgroundColor: '#D1D1C8'
      },
      {
        value: 2,
        mainTextColor: '#034AB9',
        backgroundColor: '#C8D5B9'
      },
      {
        value: 3,
        mainTextColor: '#5D2B2E',
        backgroundColor: '#CBCBFF'
      },
      {
        value: 4,
        mainTextColor: '#5E663D',
        backgroundColor: '#F9E784'
      },
      {
        value: 5,
        mainTextColor: '#9D3A02',
        backgroundColor: '#FFE9CE'
      },
      {
        value: 6,
        mainTextColor: '#2F4141',
        backgroundColor: '#DCFFC1'
      }
    ],

    analytics: [
      {
        label: 'Visites par pages',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit',
        scope: 'chiennoir',
        chartType: 'visitBarChart'
      },
      {
        label: 'Détail des visites par projet',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/realisations',
        scope: 'chiennoir',
        chartType: 'visitBarChart'
      },
      {
        label: 'Répartition des appareils utilisés',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'device',
        scope: 'chiennoir',
        chartType: 'devicePieChart'
      }
    ]
  },
  kerbouzier: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Agenda',
        key: 'kbevent',
        icon: 'mmevent'
      }
    ],
    types: [
      {
        label: 'Evénement',
        value: 'event',
        bgColor: 'bg-green-700'
      },
      {
        label: 'Formation, Atelier',
        value: 'course',
        bgColor: 'bg-purple-700'
      },
      {
        label: 'Chantier Participatif',
        value: 'eco_construction',
        bgColor: 'bg-orange-600'
      }
    ],
    subtypes: [
      {
        label: 'Social',
        value: 'social',
        bgColor: 'bg-cyan-900'
      },
      {
        label: 'Tourisme',
        value: 'tourism',
        bgColor: 'bg-pink-900'
      },
      {
        label: 'Jardin',
        value: 'gardening',
        bgColor: 'bg-green-900'
      },
      {
        label: 'Constuction',
        value: 'construction',
        bgColor: 'bg-orange-900'
      }
    ],
    courses: [
      {
        label: 'Paillourte',
        value: 'paillourte'
      },
      {
        label: 'Enduit Terre',
        value: 'enduit_terre'
      },
      {
        label: 'Eco Tourisme',
        value: 'eco_tourisme'
      },
      {
        label: 'Initiation Botanique',
        value: 'initiation_botanique'
      },
      {
        label: 'Atelier Demi Journée',
        value: 'atelier_demi_journee'
      }
    ],
    membership_required: [
      {
        label: 'Adhésion annuelle à 20€',
        value: true,
        bgColor: 'bg-blue-700'
      },
      {
        label: 'Adhésion ponctuelle',
        value: false,
        bgColor: 'bg-amber-700'
      }
    ],
    duplicate_options: [
      {
        label: 'Dupliquer sur 4 semaines',
        value: 4
      },
      {
        label: 'Dupliquer sur 8 semaines',
        value: 8
      },
      {
        label: 'Dupliquer sur 12 semaines',
        value: 12
      },
      {
        label: 'Dupliquer sur 16 semaines',
        value: 16
      }
    ]
  },
  gensdemer: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Soutiens',
        key: 'gdmprospect',
        icon: 'user'
      }
    ],
    type: {
      with_repossession_rights: 'Avec droit de repirse',
      without_repossession_rights: 'Sans droit de repirse'
    },
    refund_delay: {
      five_years: '5 ans',
      ten_years: '10 ans',
      fiveteen_years: '15 ans'
    }
  },
  bassecour: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Agenda',
        key: 'bacevent',
        icon: 'mmevent'
      },
      {
        label: 'Actualité',
        key: 'bacnews',
        icon: 'news'
      },
      {
        label: 'Menu',
        key: 'bacmenu',
        icon: 'food'
      }
    ],
    type: [
      {
        label: 'Concerts',
        value: 'gig'
      },
      {
        label: 'Spectacles',
        value: 'show'
      },
      {
        label: 'Kids',
        value: 'kids'
      },
      {
        label: 'Ateliers et créativité',
        value: 'workshop'
      },
      {
        label: 'Temps forts',
        value: 'key_event'
      },
      {
        label: 'Transitions',
        value: 'transition'
      },
      {
        label: 'Jardinage',
        value: 'gardening'
      },
      {
        label: 'Vie bénévole',
        value: 'volunteers'
      },
      {
        label: 'Scène Ouverte',
        value: 'open_stage'
      },
      {
        label: 'En cuisine',
        value: 'kitchen'
      },
      {
        label: 'Danse & Open Air',
        value: 'open_air'
      }
    ],
    main_tag: [
      {
        label: 'Acteur',
        value: 'actor'
      },
      {
        label: 'Spectateur',
        value: 'spectator'
      }
    ],
    newsTypes: [
      {
        label: 'Portraits-rencontres-histoires',
        value: 'bac_portraits'
      },
      {
        label: 'Vie du tiers-lieu',
        value: 'bac_tiers_lieu'
      },
      {
        label: 'Outils',
        value: 'bac_outils'
      },
      {
        label: "Offres d'emploi",
        value: 'bac_offre_d_emploi'
      },
      {
        label: 'Transitions',
        value: 'bac_transitions'
      }
    ],
    propertyTypes: [
      {
        label: 'Autres tags',
        value: 'bac_other_tags'
      },
      {
        label: 'Lieu',
        value: 'bac_place'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ]
  },
  nouvelleparenthese: {
    titleSize: 'text-xl',
    apps: [
      {
        label: 'Prestations',
        key: 'show',
        icon: 'show'
      }
    ],
    propertyTypes: [
      {
        icon: 'pi pi-map',
        type: 'np_location'
      },
      {
        icon: 'pi pi-hashtag',
        type: 'np_theme'
      }
    ]
  },
  banquetceleste: {
    titleSize: 'text-lg',
    availableLanguages: ['fr', 'en'],
    apps: [
      {
        label: 'Audience',
        key: 'analytics',
        icon: 'analytics'
      },
      {
        label: 'Programmes',
        key: 'program',
        icon: 'program'
      },
      {
        label: 'Ressources',
        key: 'resource',
        icon: 'resource'
      }
    ],
    resourceTypes: [
      {
        value: 'record',
        label: 'Disque',
        icon: 'vinyl'
      },
      {
        value: 'podcast',
        label: 'Podcast',
        icon: 'micro'
      },
      {
        value: 'video',
        label: 'Vidéo',
        icon: 'camera'
      }
    ],
    programTypes: [
      {
        value: 'concert',
        label: 'Concert'
      },
      {
        value: 'show',
        label: 'Spectacle'
      },
      {
        value: 'festival',
        label: 'Festival'
      },
      {
        value: 'cultural_action',
        label: 'Action culturelle'
      }
    ],
    availableNewsSources: [
      {
        label: 'Télérama',
        value: 'telerama',
        logo: '/press/telerama.svg'
      },
      {
        label: 'Olyrix',
        value: 'olyrix',
        logo: '/press/olyrix.svg'
      },
      {
        label: 'Unidivers',
        value: 'unidivers',
        logo: '/press/unidivers.svg'
      },
      {
        label: 'Baroquiades',
        value: 'baroquiades',
        logo: '/press/baroquiades.webp'
      },
      {
        label: 'BBC Music',
        value: 'bbc-music',
        logo: '/press/bbc.webp'
      },
      {
        label: 'Classica',
        value: 'classica',
        logo: '/press/choc_classica.webp'
      },
      {
        label: 'Concerti magazin',
        value: 'concerti-magazin',
        logo: '/press/concert-magazin.webp'
      },
      {
        label: 'Crescendo',
        value: 'crescendo',
        logo: '/press/crescendo-magazine.webp'
      },
      {
        label: 'Diapason',
        value: 'diapason',
        logo: '/press/Diapason.webp'
      },
      {
        label: 'Early Music World',
        value: 'early-music-world',
        logo: '/press/telerama.svg'
      },
      {
        label: 'Forum Opéra',
        value: 'forum-opera',
        logo: '/press/forumopera.webp'
      },
      {
        label: 'France 3',
        value: 'france-3',
        logo: '/press/france3.webp'
      },
      {
        label: 'France Info',
        value: 'france-info',
        logo: '/press/telerama.svg'
      },
      {
        label: 'France Musique',
        value: 'france-musique',
        logo: '/press/france-musique.webp'
      },
      {
        label: 'Gramophone',
        value: 'gramophone',
        logo: '/press/Gramophone.webp'
      },
      {
        label: "L'Obs",
        value: 'l-obs',
        logo: '/press/nouvelobs.webp'
      },
      {
        label: 'La Croix',
        value: 'la-croix',
        logo: '/press/la-croix.webp'
      },
      {
        label: 'LCI',
        value: 'lci',
        logo: '/press/LCI.webp'
      },
      {
        label: 'Le Monde',
        value: 'le-monde',
        logo: '/press/le_monde.webp'
      },
      {
        label: 'Musikzen',
        value: 'musikzen',
        logo: '/press/Musikzen.webp'
      },
      {
        label: "Musiq'3",
        value: 'musiq-3',
        logo: '/press/Musiq-3.webp'
      },
      {
        label: 'Opéra Magazine',
        value: 'opera-magazine',
        logo: '/press/opera-magazine.webp'
      },
      {
        label: 'Planet Hugill',
        value: 'planet-hugill',
        logo: '/press/hughill.webp'
      },
      {
        label: 'Res Musica',
        value: 'res-musica',
        logo: '/press/res_musica.webp'
      },
      {
        label: 'RTBF',
        value: 'rtbf',
        logo: '/press/RTBF.webp'
      },
      {
        label: 'Scherzo',
        value: 'scherzo',
        logo: '/press/scherzo-magazine.webp'
      }
    ],
    common: {
      statusTypes: [
        {
          label: 'Brouillon',
          value: 'draft',
          bgColor: 'bg-orange-500'
        },
        {
          label: 'Publié',
          value: 'published',
          bgColor: 'bg-green-700'
        }
      ]
    },
    analytics: [
      {
        label: 'Visites par pages',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit',
        scope: 'banquetceleste',
        chartType: 'visitBarChart'
      },
      {
        label: 'Détail des visites par ressource',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/ressources',
        scope: 'banquetceleste',
        chartType: 'visitBarChart'
      },
      {
        label: 'Détail des visites par programme',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/ressources',
        scope: 'banquetceleste',
        chartType: 'visitBarChart'
      },
      {
        label: 'Répartition des appareils utilisés',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'device',
        scope: 'banquetceleste',
        chartType: 'devicePieChart'
      }
    ]
  },
  jeunedargentre: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Athlétisme',
        key: 'athletisme',
        icon: 'athletisme'
      },
      {
        label: 'Basket',
        key: 'basket',
        icon: 'basket'
      },
      {
        label: 'Football',
        key: 'football',
        icon: 'football'
      },
      {
        label: 'Gymnastique',
        key: 'gymnastique',
        icon: 'gymnastique'
      },
      {
        label: 'Tennis',
        key: 'tennis',
        icon: 'tennis'
      },
      {
        label: 'Tennis de Table',
        key: 'tennis-de-table',
        icon: 'tennisdetable'
      },
      {
        label: 'Théâtre',
        key: 'theatre',
        icon: 'theatre'
      },
      {
        label: 'Viet Vo Dao',
        key: 'viet-vo-dao',
        icon: 'vietvodao'
      },
      {
        label: 'Cinéma',
        key: 'cinema',
        icon: 'cinema'
      },
      {
        label: 'Amicale',
        key: 'amicale',
        icon: 'amicale'
      },
      {
        label: 'Association',
        key: 'association',
        icon: 'association'
      }
    ]
  },
  maisonmousse: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Évènements',
        key: 'mmevent',
        icon: 'mmevent'
      },
      {
        label: 'Participants',
        key: 'attendees',
        icon: 'attendees'
      }
    ],
    tags: [
      {
        label: 'Comprendre',
        value: 'comprendre'
      },
      {
        label: "S'inspirer",
        value: 'inspirer'
      },
      {
        label: 'Imaginer',
        value: 'imaginer'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ]
  },
  dejademain: {
    titleSize: 'text-xl',
    apps: [
      {
        label: 'Projets',
        key: 'ddproject',
        icon: 'ddproject'
      },
      {
        label: 'Produits',
        key: 'ddproduct',
        icon: 'ddproduct'
      }
    ],
    type: [
      {
        label: 'Lumière',
        value: 'light'
      },
      {
        label: 'Décoration',
        value: 'decoration'
      },
      {
        label: 'Mobilier',
        value: 'furniture'
      },
      {
        label: 'Support-partitionnement',
        value: 'support'
      }
    ]
  },

  whisper: {
    titleSize: 'text-2xl',
    apps: [
      {
        label: 'Avis Client',
        key: 'review',
        icon: 'review'
      }
    ],
    inProgress: [
      {
        label: 'Projet en cours',
        value: true,
        bgColor: 'bg-yellow-500',
        icon: 'in_progress'
      },
      {
        label: 'Projet terminé',
        value: false,
        bgColor: 'bg-green-700',
        icon: 'check'
      }
    ]
  },
  caeterra: {
    titleSize: 'text-3xl',
    apps: [
      {
        label: 'Contenus',
        key: 'content',
        icon: 'content'
      },
      {
        label: 'Produits',
        key: 'product',
        icon: 'product'
      },
      {
        label: 'Articles',
        key: 'news',
        icon: 'news'
      }
    ],
    newsTypes: [
      {
        label: 'Article interne',
        value: 'INTERNAL'
      },
      {
        label: 'Article de presse',
        value: 'EXTERNAL'
      }
    ],
    documentTypes: [
      {
        label: "Plaquette Compost'ici",
        value: 'compostici_pdf'
      },
      {
        label: 'Plaquette Terrefertile',
        value: 'terrefertile_pdf'
      }
    ]
  },
  quatrebis: {
    titleSize: 'text-xl',
    apps: [
      {
        label: 'Évènements',
        key: 'qbevent',
        icon: 'mmevent'
      },
      {
        label: 'Articles',
        key: 'qbnews',
        icon: 'news'
      },
      {
        label: 'Temps forts / Alumni',
        key: 'qbhighlight',
        icon: 'association'
      },
      {
        label: 'Dates D-code',
        key: 'qbdate',
        icon: 'event'
      },
      {
        label: 'Fichiers',
        key: 'qbfiles',
        icon: 'document'
      },
      {
        label: 'Informations complémentaires',
        key: 'qbpills',
        icon: 'shape'
      }
    ],
    type: [
      {
        label: 'Forum',
        value: 'forum'
      },
      {
        label: 'Concerts',
        value: 'concerts'
      },
      {
        label: 'Expositions',
        value: 'expositions'
      },
      {
        label: 'Ateliers & Rencontres',
        value: 'ateliers_rencontres'
      },
      {
        label: 'Festivals',
        value: 'festivals'
      },
      {
        label: 'Marches des créateurices',
        value: 'marches_des_createurices'
      },
      {
        label: 'Autres',
        value: 'autres'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ],
    place: [
      {
        label: 'Bâtiment A',
        value: 'batiment_a'
      },
      {
        label: 'Bâtiment B',
        value: 'batiment_b'
      },
      {
        label: 'Centre Info',
        value: 'centre_info'
      },
      {
        label: 'Café à Projets',
        value: 'cafe_a_projets'
      },
      {
        label: 'Facade du 360',
        value: 'facade_360'
      },
      {
        label: 'Facade du Café à Projets',
        value: 'facade_café_à_projets'
      },
      {
        label: '360',
        value: '360'
      },
      {
        label: 'Hors les murs',
        value: 'hors_les_murs'
      },
      {
        label: 'Salle de spectacle',
        value: 'salle_de_spectacle'
      }
    ],

    propertyTypes: [
      {
        label: 'Thémtique',
        value: 'qb_thematique'
      }
    ],
    highlightType: [
      { label: 'Temps fort', value: 'highlight' },
      {
        label: 'Alumni',
        value: 'alumni'
      }
    ],
    dateType: [
      {
        label: 'Délégué.e du Défenseur des Droits',
        value: 'delegue_defenseur_des_droits'
      },
      {
        label: 'Asfad',
        value: 'asfad'
      },
      {
        label: 'Mouvement contre le Racisme et pour l’Amitié entre les Peuples (MRAP)',
        value: 'mrap'
      },
      {
        label: 'Avocat·es',
        value: 'avocat'
      },
      {
        label: 'D-Code (Clair-Détour)',
        value: 'd_code_cd'
      },
      {
        label: 'D-Code (Karrez)',
        value: 'd_code_k'
      },
      {
        label: 'Autre',
        value: 'autre'
      }
    ],
    selectButtonDCodeOptions: [
      {
        label: 'Rendez-vous futurs',
        value: false
      },
      {
        label: 'Rendez-vous passés',
        value: true
      }
    ],
    filePage: [
      {
        label: 'Centre Info',
        value: 'qb_page_centre_info'
      },
      { label: 'PAEJ: Point Accueil Ecoute Jeunes', value: 'qb_page_paej' },
      { label: 'D-Code (Karrez)', value: 'qb_page_dcode' },
      { label: 'PILJ: Point Info Logement Jeunes', value: 'qb_page_pilj' },
      { label: 'Café à Projets', value: 'qb_page_cafe_a_projets' },
      { label: 'Expositions', value: 'qb_page_expositions' },
      { label: 'Salle de spectacle', value: 'qb_page_salle_spectacle' },
      { label: 'Le Labo', value: 'qb_page_labo' },
      { label: 'Itinéraire Bis', value: 'qb_page_itineraire_bis' },
      { label: "Bourse d'été", value: 'qb_page_bourse_ete' },
      { label: 'FRIJ (Fond Rennais d’Initiatives Jeunes)', value: 'qb_page_frij' },
      { label: 'PACC (Point d’Accès aux Centres de Contestation)', value: 'qb_page_pacc' },
      { label: 'Prev En Ville', value: 'qb_page_prevenville' }
    ],

    pillsType: [
      {
        label: "Bourse d'été",
        value: 'bourse_d_ete'
      },

      {
        label: 'PAEJ: Point Accueil Ecoute Jeunes',
        value: 'paej'
      },
      {
        label: 'PILJ: Point Info Logement Jeunes',
        value: 'pilj'
      }
    ]
  },
  diardexpertise: {
    titleSize: 'text-lg',
    apps: [
      {
        label: 'Articles',
        key: 'news',
        icon: 'news'
      },
      {
        label: 'Propriétés',
        key: 'defproperty',
        icon: 'property'
      }
    ],
    propertyTypes: [
      {
        label: 'Mots-clés',
        value: 'def_keywords'
      }
    ],
    availableNewsTypes: [
      {
        value: 'conseil',
        label: 'Conseil'
      },
      {
        value: 'actualite',
        label: 'Actualité'
      }
    ]
  }
};
